<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Alert</h1>
                <p>Ci sono {{ get().length }} alert registrati nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="downloadAlertCsv()">Scarica alert</button>
            </div>
        </div>
    </div>

    <!-- FILTRI -->
    <div class="row mb-3" id="accordion">
        <div class="col">
            <div class="card">
                <div class="card-header" id="filters_header">
                    <h5 class="mb-0">
                        <button class="btn btn-primary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" (click)="filter_expanded = !filter_expanded">
                            Mostra filtri<i class="fas ml-3" [ngClass]="{'fa-chevron-down': !filter_expanded, 'fa-chevron-up': !!filter_expanded}"></i>
                        </button>
                    </h5>
                </div>

                <div id="collapseOne" class="collapse" aria-labelledby="filters_header" data-parent="#accordion">
                    <div class="card-body pb-0">
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona gruppo</label>
                                <select name="group_select" id="group_select" class="form-control" [(ngModel)]="filter.group" (change)="populateAlerts()">
                                    <option value="">-</option>
                                    <option [value]="group.id" *ngFor="let group of window.usher.get()?.public_configuration?.groups; index as i">{{ group.name }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona cliente</label>
                                <select name="client_select" id="client_select" class="form-control" [(ngModel)]="filter.client" (change)="populateAlerts()">
                                    <option value="">-</option>
                                    <option [value]="window.usher.getPublicToken()">{{ window.usher.getPublicConfiguration()?.nome }}</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'cliente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="type">Seleziona dipendente</label>
                                <select name="worker_select" id="worker_select" class="form-control" [(ngModel)]="filter.worker" (change)="populateAlerts()">
                                    <option value="">-</option>
                                    <option [value]="user.public_token" *ngFor="let user of getUsers(undefined, 'dipendente'); index as i">{{ user.public_configuration?.nome }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label>Da</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_from.show()">{{ window.flowup.utils.getDateTime(filter.from) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>A</label>
                                <span class="form-control cursor-pointer background-hover" (click)="datepicker_filter_to.show()">{{ window.flowup.utils.getDateTime(filter.to) }}</span>
                            </div>
                            <div class="col-12 col-md-4">
                                <label>Filtro di ricerca</label>
                                <input type="text" class="form-control" id="filter_text" name="filter_text" [(ngModel)]="filter.text" (keyup)="populateAlerts()">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col">
                                <button type="button" class="btn btn-primary float-right" (click)="resetFilter()">Resetta filtri</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Dipendente</th>
                            <th scope="col">Cliente</th>
                            <th scope="col">Data</th>
                            <th scope="col">Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row cursor-pointer background-hover" *ngFor="let alert of get(); index as i" (click)="handleModal(alert.public_token, 'update')">
                            <td scope="col">{{ getUsers(alert.configuration?.owner)[0]?.public_configuration?.nome || "Non rilevato" }}</td>
                            <td scope="col">{{ getUsers(alert.configuration?.client)[0]?.public_configuration?.nome || "Non rilevato" }}</td>
                            <td scope="col">{{ window.flowup.utils.getDateTime(alert.creation_timestamp) }}</td>
                            <td scope="col text-capitalize">{{ getDescriptionAlert(alert) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<span id="alertModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <p><b>Dipendente:</b> {{ getUsers(getAlert().configuration?.owner)[0]?.public_configuration?.nome || "Non rilevato" }}</p>
                            <p><b>Cliente:</b> {{ getUsers(getAlert().configuration?.client)[0]?.public_configuration?.nome || "Non rilevato" }}</p>
                            <p><b>Sede:</b> {{ getAssegnazioni(getAlert().configuration?.assegnazione)[0]?.configuration?.sede || "Non specificata" }}</p>
                            <p><b>Geolocalizzazione:</b> <span [innerHtml]="getPosition(getAlert())"></span></p>
                            <p>{{ getDescriptionAlert(getAlert()) }}</p>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="handleModal(getAlert().public_token, 'delete')">Elimina</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteAlertModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Conferma</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getAlert().public_token, 'update')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <p>Sei sicuro di voler eliminare questo alert?</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger" [hidden]="!getAlert().public_token || queryparams()['type'] != 'delete'" (click)="deleteAlert()">Elimina</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="handleModal(getAlert().public_token, 'update')">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>